import { useState, useEffect, useCallback } from 'react'
import { getCashClosings, type CashClosing } from '@/api/cash-closings'

export function useActiveCashClosing() {
  const [activeClosure, setActiveClosure] = useState<CashClosing | null>(null)
  const [loading, setLoading] = useState(true)

  const refresh = useCallback(() => {
    getCashClosings()
      .then(r => {
        const active = r.closings
          .filter(c => c.status === 'draft')
          .sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())[0] ?? null
        setActiveClosure(active)
      })
      .catch(() => setActiveClosure(null))
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    refresh()
    window.addEventListener('cash-closings-changed', refresh)
    return () => window.removeEventListener('cash-closings-changed', refresh)
  }, [refresh])

  return { activeClosure, loading }
}
